import $ from 'jquery';
var Isotope = require('isotope-layout');

if (document.querySelector('.isotoped')) {
    var qsRegex;
    var buttonFilter;

    var iso = new Isotope('.isotoped', {
        percentPosition: true,
        itemSelector: '.isotope-item',
        masonry: {
            columnWidth: '.grid-sizer',
            gutter: 20,
        },
        filter: function() {
            var $this = $(this);
            var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
            var buttonResult = buttonFilter ? $this.is(buttonFilter) : true;
            return searchResult && buttonResult;
        },
        stagger: 50,
    });

    $('.js-filter-button-group').on('click', 'button', function() {
        buttonFilter = $(this).attr('data-filter');

        $('.js-filter-button-group').find('.btn-activated').each((i, button) => {
            $(button).removeClass('btn-activated');
        });

        if ($(this).hasClass('dropdown-item')) {
            $(this).closest('.dropdown').find('.dropdown-toggle').addClass('btn-activated');
        }

        $(this).addClass('btn-activated');

        iso.arrange();

        if (iso.filteredItems.length === 0) {
            $('.js-empty-result-message').attr('hidden', false);
        } else {
            $('.js-empty-result-message').attr('hidden', true);
        }
    });

    $('.js-filter-search-form').on('submit', function(e) {
        e.preventDefault();
        qsRegex = new RegExp($('.js-filter-search-input').val(), 'gi');
        iso.arrange();

        if (iso.filteredItems.length === 0) {
            $('.js-empty-result-message').attr('hidden', false);
        } else {
            $('.js-empty-result-message').attr('hidden', true);
        }
    });

    $('.js-filter-search-clear').on('click', function() {
        $('.js-filter-search-input').val('');
        qsRegex = new RegExp('', 'gi');
        iso.arrange();

        if (iso.filteredItems.length === 0) {
            $('.js-empty-result-message').attr('hidden', false);
        } else {
            $('.js-empty-result-message').attr('hidden', true);
        }
    });
}



// WEBPACK FOOTER //
// ./scripts/isotope.js